import { envManager, env } from '@accor/customer-core'
import { getTokenErrorHandler } from '@/services/getTokenErrorHandler'
import { AdsLink } from '@accor/ads-components'
import { configure as customerApiConfigure } from '@accor/customer-api/cloud'
import { i18nService } from '@accor/customer-vue-services'
import { isWebView } from '@accor/customer-api/cloud'
import prodConfig from '../../config/config-pro.json'

export const configureEnv = async () => {
  await envManager.configure(
    'all.accor.com',
    {
      ...prodConfig,
      isOneTrustEnabled: !isWebView(),
      // Prevent RUM in E2E tests
      splunkRUM: window.location.hostname !== 'localhost' ? prodConfig.splunkRUM : false
    },
    {
      i18nService,
      getTokenErrorHandler,
      linkComponent: AdsLink,
      getAppVersion: () => __APP_VERSION__,
      basePath: 'account'
    },
    `${import.meta.env.BASE_URL}config.json`
  )

  customerApiConfigure(env.config)
}
